// src/sections/Specialties/Specialties.js
import React from 'react';
import styles from './Specialties.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

// CORRIGÉ : Données mises à jour pour correspondre au menu
const specialtiesData = [
  { id: "specialty-rice-burger", name: "MINI RICE BURGER (4 PCS)", price: "5.90€", description: "" },
  { id: "specialty-chirashi", name: "CHIRASHI (SAUMON, THON, MIX)", price: "11.00€", description: "" }
];

const Specialties = ({ id, favorites, addFavorite, removeFavorite }) => {
  
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.specialties}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>SPÉCIALITÉS</h2>
        
        {/* CORRIGÉ : Texte et prix du supplément mis à jour */}
        <p className={styles.supplementInfo}>
          SUPPLÉMENT AVOCAT : <span className={styles.supplementPrice}>+1,00€</span>
        </p>

        <div className={styles.menuList}>
          {specialtiesData.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <div className={styles.itemContentWrapper}> 
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>

              </div>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialties;